import { EPageTypes, EPlatformTypes, handleDynamicCalltracking } from '@cian/frontend-dynamic-calltracking-component';
import { IHttpApi } from '@cian/http-api';
import { ILogger } from '@cian/logger';
import { TDeviceType } from '@cian/ui-kit/types';

interface IComagicProps {
  comagicId: number | null;
  placeType: string;
  announcementId: number;
  queryString?: string | null;
  deviceType?: TDeviceType;
  isMap?: boolean;
}

interface IContextcProps {
  logger: ILogger;
  httpApi: IHttpApi;
}

export const fetchComagic = async (
  { comagicId, placeType, announcementId, queryString, isMap, deviceType }: IComagicProps,
  { logger, httpApi }: IContextcProps,
): Promise<string | null> => {
  if (comagicId) {
    const additionalParams = isMap
      ? {
          platformType: deviceType === 'desktop' ? EPlatformTypes.WebDesktop : EPlatformTypes.WebMobile,
          pageType: EPageTypes.Map,
        }
      : { platformType: EPlatformTypes.WebMobile, pageType: EPageTypes.OfferList };

    const dynamicCalltracking = await handleDynamicCalltracking({
      blockId: comagicId,
      httpApi,
      logger,
      placeType,
      announcementId,
      queryString,
      ...additionalParams,
    });

    if (dynamicCalltracking && dynamicCalltracking.notFormattedPhone) {
      return `+${dynamicCalltracking.notFormattedPhone}`;
    }
  }

  return null;
};
